import {
  Button,
  Form,
  // Input,
  Space,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const AddNote = ({
  selectedData,
  getRawQuantityForProduction,
  close,
  note,
}) => {
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  console.log("note", note);

  const handleAddNote = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("product_id", selectedData.id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    axios
      .post("user/commissary/create-new-standard-note", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Standard note added successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            getRawQuantityForProduction();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Form
      layout="vertical"
      name="basic"
      initialValues={{ note: note }}
      onFinish={handleAddNote}
      autoComplete="off"
    >
      <Space
        direction="vertical"
        style={{ width: "100%", margin: 0, marginTop: 20 }}
      >
        <Form.Item
          name="note"
          label=""
          rules={[
            {
              required: true,
              message: "Required",
            },
          ]}
        >
          <TextArea placeholder="Leave a note here" rows={4} size="large" />
        </Form.Item>

        {/* <Form.Item label="" style={{ marginTop: 10 }}>
          <Input
            placeholder="Set unit"
            size="large"
            // defaultValue={specProductInfo.data[0].rawproductsuserunit.unit}
          />
          <TextArea rows={4} placeholder="Leave a note here" />
        </Form.Item> */}
      </Space>

      <Form.Item
      //   style={{ marginTop: "20px" }}
      >
        <Button
          type="primary"
          loading={loadings}
          htmlType="submit"
          style={{ width: "100%", borderRadius: "20px" }}
        >
          {loadings ? "Loading" : "Add"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddNote;
